<template>
    <v-card v-if="['PILOT', 'PILOT_UFBB'].includes(assignment.type) && this.commentsForConstruction && Object.keys(this.commentsForConstruction).length > 0" class = "form-group-fields mb-2" elevation="6">
        <v-card-title>
            <div class="info-title-wrapper">
                <span>Πληροφορίες Αυτοψίας</span>
                <div v-if="commentsForConstruction?.rating" class="rating-wrapper">
                    <span class="rating-text">
                        Βαθμονόμιση Δυσκολίας
                    </span>
                    <v-rating
                        :value="commentsForConstruction?.rating"
                        class="rating"
                        :readonly="true"
                        :clearable="false"
                    >
                        <template v-slot:item="props">
                            <div class="rating-icon-wrapper">
                                <v-icon
                                    :color="props.isFilled ? hardnessColors[props.index] : 'grey lighten-1'"
                                    large
                                    class="rating-icon"
                                    @click="props.click"
                                >
                                    {{ props.isFilled ? 'mdi-star-circle' : 'mdi-star-circle-outline' }}
                                </v-icon>
                                <span v-if="props.index === 0" class="rating-text">
                                    Έυκολο
                                </span>
                                <span v-if="props.index === hardnessColors.length - 1" class="rating-text">
                                    Δύσκολο
                                </span>
                            </div>
                        </template>
                    </v-rating>
                </div>
            </div>
        </v-card-title>
        <div class = "autopsy-info-first">
            <div v-if="assignment.cabin" class="field d-flex"><h4 class="pr-1">Καμπίνα: </h4> {{ assignment.cabin }}</div>
            <div v-if="assignment.cabinAddress" class="field d-flex">
                <h4 class="pr-1">Διεύθυνση Καμπίνας: </h4> {{ assignment.cabinAddress }}
                <v-icon v-if="/^-?\d+\.\d+\s*,\s*-?\d+\.\d+$/.test(assignment.cabinAddress.replace(/\s/g, ''))" large class="google-maps-icon" @click.stop="openMapOnCoordinates(assignment.cabinAddress)">mdi-google-maps</v-icon>
            </div>
            <div v-if="assignment.pipe" class="field d-flex"><h4 class="pr-1">Σωληνίσκος: </h4> {{ assignment.pipe }}</div>
            <div v-if="commentsForConstruction?.option" class="field d-flex"><h4 class="pr-1">{{ optionTitle }}: </h4> {{ selectedOptionName }}</div>
        </div>
        <div>
            <v-textarea
                v-if="commentsForConstruction?.comment"
                :value="commentsForConstruction.comment"
                filled
                label="Σχόλια από την Αυτοψία"
                rows="4"
                row-height="10"
                :readonly="true"
                class="field-comment"
            ></v-textarea>
        </div>
    </v-card>
</template>

<script>
    export default {
        props: {
            assignment: {
                type: Object,
                required: true
            },
            propertyTab: {
                type: String,
                required: true
            }
        },
        computed: {
            config() {
                return this.$store.getters.getConfig || {}
            },
            earthworkOptions() {
                return this.config?.autopsy?.earthworkOptions || []
            },
            constructionOptions() {
                return this.config?.autopsy?.constructionOptions || []
            },
            blowingOptions() {
                return this.config?.autopsy?.blowingOptions || []
            },
            selectedOptionName() {
                let options = []
                switch (this.propertyTab) {
                case 'earthwork': { options = this.earthworkOptions; break }
                case 'blowing': { options = this.blowingOptions; break }
                case 'construction': { options = this.constructionOptions; break }
                }
                const option = options.find(option => option.value === this.commentsForConstruction.option)
                if (option) {
                    return option.name
                }
                return ''
            },
            optionTitle() {
                switch (this.propertyTab) {
                case 'earthwork': { return 'Είδος Χωματουργικών' }
                case 'blowing': { return 'Είδος Outdoor Ίνας' }
                case 'construction': { return 'Είδος Όδευσης Floor Boxes από' }
                }
                return ''
            },
            commentsForConstruction() {
                return this.assignment.autopsy?.commentsForConstruction?.[this.propertyTab]
            }
        },
        data() {
            return {
                hardnessColors: ['#094A25', '#0C6B37', '#F8B324', '#EB442C', '#BC2023']
            }
        },
        methods: {
            openMapOnCoordinates(coordinates) {
                window.open(`https://www.google.com/maps?q=${coordinates}`, '_blank')
            }
        }
    }
</script>
<style scoped>
.google-maps-icon {
    color: rgb(138, 0, 0);
}

.google-maps-icon:hover {
    color: red;
}
.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}
.info-title-wrapper {
    width: 100%;
}
.rating-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
}
.rating-text {
    font-size: 0.8rem;
    color:gray;
}
.rating {
    display: flex;
    justify-content: space-evenly;
}
.rating-icon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.autopsy-info-first {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
}
.rating-icon {
    padding-bottom: 0;
    padding-top: 0;
}
.field {
    padding: 0.2rem;
    align-items: center;
}

.field-comment {
    width: 100%;
}
</style>
